module.exports = __webpack_public_path__ + "img/QUEL_logo.df4455bf.svg";